import http from "@/utils/http";


export const MessagePushConfigurationApi = {

    getMessagePushConfigurationByCurrentCompany() {
        return http.get(`/messagePushConfiguration/getMessagePushConfigurationByCurrentCompany`)
    },
    updateMessagePushConfiguration(data) {
        return http.post(`/messagePushConfiguration/updateMessagePushConfiguration`,data)
    },
}